!function (e, t) {
  "object" == typeof exports && "undefined" != typeof module ? t(exports, require("@emotion/core"), require("react")) : "function" == typeof define && define.amd ? define(["exports", "@emotion/core", "react"], t) : t((e = "undefined" != typeof globalThis ? globalThis : e || self).BreakpointContext = {}, e.core, e.React);
}(this, function (e, t, r) {
  "use strict";

  var n = {
    currentBp: ""
  },
      o = r.createContext(n);
  e.BreakpointContext = o, e.BreakpointProvider = function (e) {
    var i = e.children,
        u = r.useState(n),
        c = u[0],
        a = u[1];
    return r.useEffect(function () {
      var e,
          t,
          r,
          n = (e = function e() {
        var e = window.getComputedStyle(document.body, "::before").getPropertyValue("content").replace(/"/g, "");
        c.currentBp !== e && a({
          currentBp: e
        });
      }, t = 100, function () {
        for (var n = [], o = 0; o < arguments.length; o++) {
          n[o] = arguments[o];
        }

        var i = function i() {
          return e.apply(void 0, n);
        };

        clearTimeout(r), r = setTimeout(i, t);
      });
      return n(), window.addEventListener("resize", n), function () {
        window.removeEventListener("resize", n);
      };
    }, []), t.jsx(o.Provider, {
      value: c
    }, i);
  }, Object.defineProperty(e, "__esModule", {
    value: !0
  });
});